import React, { useEffect, useState } from 'react';
import Calender from '../../Assets/images/calender.png';
import { Col, Container, Form, Row } from 'react-bootstrap';
import EngagementRing from '../../Assets/images/engagement-ring.png';
import WeddingBand from '../../Assets/images/wedding-band.png';
import Earring from '../../Assets/images/earrings.png';
import FashionJewel from '../../Assets/images/fashion-jewelry.png';
import Return from '../../Assets/images/return.png';
import Repair from '../../Assets/images/repairs.png';
import Inquiry from '../../Assets/images/inquiry.png';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { base_url, postHeader } from '../../Helper/request';
import { useParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from 'react-redux';
import { store_locations } from '../../Reducer/homeReducer';

const CustomInquery = (props) => {
    const specificDisabledDate = new Date('2024-05-27');
    const isDateDisabled = (date) => {
        const isSunday = date.getDay() === 0; // Check if the date is Sunday (0 = Sunday)
        const isSpecificDate =
            date.getFullYear() === specificDisabledDate.getFullYear() &&
            date.getMonth() === specificDisabledDate.getMonth() &&
            date.getDate() === specificDisabledDate.getDate();

        return isSunday || isSpecificDate;
    };

    const [captchaStatus, setcaptchaStatus] = useState(true);
    const capthcaHandle = (res) => {
        if (res) {
            setcaptchaStatus(false);
        }
    };
    const isWeekday = (date) => {
        const day = date.getDay();
        return day !== 0
    };
    function padTo2Digits(num) {
        return num.toString().padStart(2, '0');
    }
    function formatDate(date) {
        return [
            date.getFullYear(),
            padTo2Digits(date.getMonth() + 1),
            padTo2Digits(date.getDate()),
        ].join('-');
    }


    const storeLocation = useSelector(state => state.persistedReducer.home.store_locations)
    const [startDate, setStartDate] = useState(new Date());
    const { location } = useParams();
    const dispatch = useDispatch();
    const [loader, setloader] = useState(false);
    const clearAll = () => {
        setcontactData({
            ...contactData,
            visit_reason: "",
            first_name: "",
            last_name: "",
            email: "",
            phone: "",
            location: "",
            comment: "",
            date: "",
            time: "",
            productLink: ""
        })
    }
    const [contactData, setcontactData] = useState({
        product_id: window.location.pathname == "/person-appointment" ? "" : props.product_id,
        visit_reason: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        location: location,
        comment:  "",
        date: "",
        time: "",
        productLink: props.productLink
    });
    const [validations, setValidations] = useState({
        visit_reason: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        location: "",
        comment: "",
        date: "",
        time: ""
    })

    const [ifSaturday, setifSaturday] = useState("");
    const inputHandler = (e, type = "other") => {
        if (type === "typeDate") {
            const day = e?.getDay();
            setifSaturday(day)
            setcontactData({
                ...contactData,
                date: e
            })
        } else {
            setcontactData({
                ...contactData,
                [e.target.name]: e.target.value
            })
        }


    }
    const validateAll = () => {
        const validations = {
            visit_reason: "",
            first_name: "",
            last_name: "",
            email: "",
            phone: "",
            location: "",
            comment: "",
            date: "",
            time: ""
        }

        let isValid = true
        // if (contactData.visit_reason == "" && window.location.pathname == "/person-appointment") {
        //     validations.visit_reason = 'Please choose reason for visit'
        //     isValid = false
        // }
        if (!contactData.phone) {
            validations.phone = 'Phone is required'
            isValid = false
        }
        if (contactData.phone && contactData?.phone.length < 10) {
            validations.phone = 'Phone must contain min 10 digits of number'
            isValid = false
        }

        if (!contactData.email) {
            validations.email = 'Email is required'
            isValid = false
        }
        if (!contactData.first_name) {
            validations.first_name = 'First name is required'
            isValid = false
        }
        if (!contactData.last_name) {
            validations.last_name = 'Last name is required'
            isValid = false
        }
        if (!contactData.location) {
            validations.location = 'Location is required'
            isValid = false
        }
        if (contactData.appointment_type === "") {
            validations.appointment_type = 'Appointment is required'
            isValid = false
        }
        // if (contactData.time === "") {
        //     validations.time = 'Time is required'
        //     isValid = false
        // }
        // if (contactData.date === "") {
        //     validations.date = 'Date is required'
        //     isValid = false
        // }


        if (contactData.email && !/\S+@\S+\.\S+/.test(contactData.email)) {
            validations.email = 'Email format must be as example@mail.com'
            isValid = false
        }

        if (!isValid) {
            setValidations(validations)
        }

        return isValid
    }
    const validateOne = (e) => {
        const { name } = e.target;

        const value = contactData[name];

        if (name == "visit_reason") {
            return true;
        }
        let message = ''

        if (!value) {
            message = `${name} is required`
        }
        // if(name==="date" && value!==""){
        //     message = ''
        // }

        if (value && name === 'email' && !/\S+@\S+\.\S+/.test(value)) {
            message = 'Email format must be as example@mail.com'
        }
        if (value && name === 'phone' && /^\d{9}$/.test(value)) {
            message = 'Phone number must be in 10 digits'
        }

        setValidations({ ...validations, [name]: message })
    }
    const onSubmit = (e) => {
        e.preventDefault();
        const isValid = validateAll();


        if (!isValid) {
            return false
        }
        setloader(true);

        const options = {
            method: "POST",
            headers: postHeader
        };

    

        const payload = {
            product_id: props.product_id,
            product_link: contactData.productLink,
            visit_reason: contactData?.visit_reason ? contactData?.visit_reason : "",
            first_name: contactData?.first_name ? contactData?.first_name : "",
            last_name: contactData?.last_name ? contactData?.last_name : "",
            email: contactData?.email ? contactData?.email : "",
            phone: contactData?.phone ? contactData?.phone : "",
            location: contactData?.location ? contactData?.location : location,
            comment:  contactData?.comment ? contactData?.comment : "",
            date: contactData?.date ? formatDate(contactData?.date) : "",
            time: contactData?.time ? contactData?.time : ""
        }
        axios.post(base_url + "/common/customProductConsultation", payload, options).then((res) => {
            if (res?.data?.status === 1) {
                toast.success(res?.data?.message);
                clearAll();
                props?.bookAppointment_handleClose()
                setloader(false);
            } else {
                toast.error(res?.data?.message);
            }
        });
    };

    // window.woopra.config({
    //     domain: "weddingdaydiamonds.com",
    //     outgoing_tracking: true,
    //     download_tracking: true,
    //     click_tracking: true
    // });

    // window.woopra.identify({
    //     first_name: contactData.first_name,
    //     last_name: contactData.last_name,
    //     email: contactData.email,
    //     phone: contactData.phone
    // });

    // window.woopra.track();



    return (
        <>
            <ToastContainer />

            <div className='page-header in-person-consult-header'>
                <h1 className='page-title text-center text-uppercase'>Schedule an in person appointment</h1>
                <span>
                    <img src={Calender} alt='' />
                    <p className='page-subtitle text-center'>Schedule a visit and see for yourself why Wedding Day Diamonds is Minnesota's favorite engagement ring store.</p>
                </span>
            </div>

            <div className='visit-wrapper'>
                <Container className='form-container'>
                    {/* <h6 style={{display: "block"}}>Choose Reason for visit</h6> */}

                    <Form onSubmit={onSubmit}>
                    
                        <Row>
                            <Col lg={6} md={6}>
                                <Form.Group className="mb-0" controlId="formBasicEmail">
                                    <Form.Label>First Name <span>*</span></Form.Label>
                                    <Form.Control type="text" placeholder="FIRST NAME" value={contactData?.first_name} onChange={(e) => inputHandler(e)} onBlur={validateOne} name='first_name' />
                                    {
                                        validations?.first_name && <div className='validation mt-1'>
                                            {validations?.first_name.replace("_", " ")}
                                        </div>
                                    }
                                </Form.Group>


                            </Col>
                            <Col lg={6} md={6}>
                                <Form.Group className="mb-0" controlId="formBasicEmail">
                                    <Form.Label>Last Name <span>*</span></Form.Label>
                                    <Form.Control type="text" placeholder="LAST NAME" value={contactData?.last_name} onChange={(e) => inputHandler(e)} onBlur={validateOne} name='last_name' />
                                    {
                                        validations?.last_name && <div className='validation mt-1'>
                                            {validations?.last_name.replace("_", " ")}
                                        </div>
                                    }
                                </Form.Group>

                            </Col>
                            <Col lg={6} md={6}>
                                <Form.Group className="mb-0" controlId="formBasicEmail">
                                    <Form.Label>Email <span>*</span></Form.Label>
                                    <Form.Control type="email" placeholder="EMAIL" value={contactData?.email} onChange={(e) => inputHandler(e)} onBlur={validateOne} name='email' />
                                    {
                                        validations?.email && <div className='validation mt-1'>
                                            {validations?.email.replace("_", " ")}
                                        </div>
                                    }
                                </Form.Group>

                            </Col>
                            <Col lg={6} md={6}>
                                <Form.Group className="mb-0" controlId="formBasicEmail">
                                    <Form.Label>Phone Number <span>*</span></Form.Label>
                                    <Form.Control type="number" placeholder="Phone Number" value={contactData?.phone} onChange={(e) => inputHandler(e)} onBlur={validateOne} name='phone' />
                                    {
                                        validations?.phone && <div className='validation mt-1'>
                                            {validations?.phone.replace("_", " ")}
                                        </div>
                                    }
                                </Form.Group>

                            </Col>
                            <Col lg={10} md={10}>
                                <Form.Group className="mb-0" controlId="formBasicEmail">
                                    <Form.Label className='text-uppercase'>Product Link </Form.Label>
                                    <Form.Control as="textarea" style={{height: "45px"}} placeholder="Notes" rows={2} name="comment" value={contactData?.productLink} onChange={(e) => inputHandler(e)} />
                                </Form.Group>

                            </Col>
                            <Col lg={10} md={10}>
                                <Form.Group className="mb-0" controlId="formBasicEmail">
                                    <Form.Label className='text-uppercase'>Please Provide Any Additional notes. </Form.Label>
                                    <Form.Control style={{height: "45px"}} as="textarea" placeholder="Notes" rows={3} name="comment" value={contactData?.comment} onChange={(e) => inputHandler(e)} />
                                </Form.Group>

                            </Col>
                            <Col lg={6} md={6}>
                                <Form.Group className="mb-0" controlId="formBasicEmail">
                                    <Form.Label>Location <span>*</span></Form.Label>
                                    <Form.Select value={contactData?.location} aria-label="Default select example" onChange={(e) => inputHandler(e)} onBlur={validateOne} name='location'>
                                        <option>Choose Location</option>
                                        {storeLocation?.map(stores =>
                                            <option value={stores.location}>{stores.location}</option>
                                        )}

                                    </Form.Select>
                                    {
                                        validations?.location && <div className='validation mt-1'>
                                            {validations?.location.replace("_", " ")}
                                        </div>
                                    }
                                </Form.Group>

                            </Col>
                            <Col></Col>
                            <Col lg={6} md={6}>

                                <Form.Group className="mb-0" controlId="formBasicEmail">
                                    <Form.Label>Date </Form.Label>
                                    {/* <Form.Control type="date" onChange={(e) => inputHandler(e)} onBlur={validateOne} name='date' /> */}
                                    <DatePicker
                                        placeholderText="Choose Date" minDate={new Date()} filterDate={(date) => !isDateDisabled(date)} className='form-control w-100' selected={contactData?.date}
                                        onChange={(e) => inputHandler(e, "typeDate")}
                                        onBlur={validateOne} name='date' />
                                    {/* <Form.Select aria-label="Default select example" onChange={(e) => inputHandler(e)} onBlur={validateOne} name='date'>
                                        <option>Choose Date</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                    </Form.Select> */}
                                    {/* {
                                        validations?.date && <div className='validation mt-1'>
                                            {validations?.date.replace("_", " ")}
                                        </div>
                                    } */}
                                </Form.Group>
                            </Col>
                            <Col></Col>
                            <Col lg={6} md={6}>
                                <Form.Group className="mb-0" controlId="formBasicEmail">
                                    <Form.Label>Time </Form.Label>
                                    <Form.Select aria-label="Default select example" onChange={(e) => inputHandler(e)} onBlur={validateOne} name='time'>
                                        <option>Choose a Time</option>
                                        {
                                            ifSaturday == 6 && <option value="10:00 am - 11:00 am">10:00 am - 11:00 am</option>
                                        }
                                        <option value="11:00 am - 12:00 pm">11:00 am - 12:00 pm</option>
                                        <option value="12:00 pm - 1:00 pm">12:00 pm - 1:00 pm</option>
                                        <option value="1:00 pm - 2:00 pm">1:00 pm - 2:00 pm</option>
                                        <option value="2:00 pm - 3:00 pm">2:00 pm - 3:00 pm</option>
                                        <option value="3:00 pm - 4:00 pm">3:00 pm - 4:00 pm</option>
                                        <option value="4:00 pm - 5:00 pm">4:00 pm - 5:00 pm</option>
                                        <option value="5:00 pm - 6:00 pm">5:00 pm - 6:00 pm</option>
                                        {
                                            ifSaturday !== 6 && <option value="6:00 pm - 7:00 pm">6:00 pm - 7:00 pm</option>
                                        }
                                    </Form.Select>
                                    {/* {
                                        validations?.time && <div className='validation mt-1'>
                                            {validations?.time.replace("_", " ")}
                                        </div>
                                    } */}
                                </Form.Group>
                            </Col>
                            <Col></Col>
                            <Col lg={12}>
                                <div className='mt-3'>
                                    <ReCAPTCHA
                                        sitekey="6Lc6LUscAAAAAKO2DYPGrIPSnwx3fzROCxJzNWQ0"
                                        onChange={capthcaHandle}
                                    />
                                </div>
                                <button 
                                disabled={captchaStatus ? true : false}
                                 className='btn inner-theme-btn'>{loader ? "Sending..." : "Schedule"}</button>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
        </>
    )
}

export default CustomInquery;